/**
 * EvaluationFormV2Preview — preview page for Phase 3A.
 *
 * Mounted at /eval-v2-preview/:templateId so we can validate UX
 * before wiring V2 into the real evaluation send/submit flow.
 *
 * Reads the V2 template from /api/templates/v2/{id}.
 * Submit is a no-op (toast only) — no DB writes during pilot review.
 */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "../../lib/api";
import EvaluationFormV2 from "./EvaluationFormV2";

export default function EvaluationFormV2Preview() {
  const { templateId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const playerName = searchParams.get("player") || "";

  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await api.get(`/templates/v2/${templateId}`);
        if (mounted) setTemplate(data);
      } catch (e) {
        console.error(e);
        if (mounted) setError(e?.response?.data?.detail || "Kunde inte ladda template");
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [templateId]);

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center text-[rgb(var(--tn-text-71717a))]"
        data-testid="eval-v2-loading"
      >
        Laddar…
      </div>
    );
  }
  if (error) {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
        data-testid="eval-v2-error"
      >
        <p className="text-zinc-700 font-medium">Något gick fel</p>
        <p className="mt-2 text-sm text-[rgb(var(--tn-text-71717a))]">{error}</p>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mt-6 rounded-full px-5 py-2 bg-[rgb(var(--tn-bg-18181b))] text-[rgb(var(--tn-text-ffffff))] text-sm"
          data-testid="eval-v2-error-back"
        >
          Gå tillbaka
        </button>
      </div>
    );
  }

  return (
    <EvaluationFormV2
      template={template}
      playerName={playerName}
      onCancel={() => navigate(-1)}
      onSubmit={async (responses) => {
        // Phase 3A preview: log only, do not write to DB.
        console.log("[EvaluationFormV2Preview] responses:", responses);
        toast.success("Förhandsgranskning — inget sparades");
      }}
    />
  );
}
